export default function checkTokenSlashes(string, location) {
  if (string) {
    let arr = string.split("")
    if (location === "start") {
      if (arr[0] !== "/") {
        arr.unshift("/")
      }
    } else {
      if (arr[arr.length - 1] === "/") {
        arr.pop()
      }
    }
    let newString = arr.join("")
    return newString
  } else {
    return false
  }
}
